export default __webpack_public_path__ + "static/media/logo__technology__react.f64a6ebf.png";